import { useEffect, useMemo, useState } from "react";
import "./ForwardMessageModal.css";

export default function ForwardMessageModal({
  isOpen,
  conversations = [],
  selectedConversationId,
  currentUser,
  onClose,
  onConfirm,
  isSubmitting = false,
}) {
  const [query, setQuery] = useState("");
  const [selectedIds, setSelectedIds] = useState(new Set());

  useEffect(() => {
    if (!isOpen) {
      setQuery("");
      setSelectedIds(new Set());
    }
  }, [isOpen]);

  const visibleConversations = useMemo(() => {
    const lower = query.trim().toLowerCase();
    const rows = (conversations || []).map((conversation) => {
      const isGroup = conversation.type === "group";
      const otherUser = (conversation.participants || []).find((p) => p._id !== currentUser?.id);
      const title = isGroup ? conversation.name : `${otherUser?.first_name || ""} ${otherUser?.last_name || ""}`.trim();
      const avatar = isGroup ? (conversation.groupPicture || "/images/default_group.svg") : (otherUser?.picture || "/images/default_pic.png");
      return {
        id: conversation._id,
        title: title || "Conversation",
        avatar,
      };
    });

    const filtered = lower
      ? rows.filter((row) => row.title.toLowerCase().includes(lower))
      : rows;

    return filtered.sort((a, b) => {
      if (a.id === selectedConversationId) return -1;
      if (b.id === selectedConversationId) return 1;
      return 0;
    });
  }, [conversations, query, selectedConversationId, currentUser?.id]);

  const toggleSelect = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id);
      else next.add(id);
      return next;
    });
  };

  const handleConfirm = () => {
    if (!selectedIds.size || isSubmitting) return;
    onConfirm && onConfirm(Array.from(selectedIds));
  };

  if (!isOpen) return null;

  return (
    <div className="forward_modal_overlay" onClick={onClose}>
      <div className="forward_modal_sheet" onClick={(e) => e.stopPropagation()}>
        <div className="forward_modal_header">
          <h3>Forward message</h3>
          <button className="forward_close_btn" onClick={onClose}>×</button>
        </div>

        <div className="forward_search_wrap">
          <input
            className="forward_search_input"
            placeholder="Search chats"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>

        <div className="forward_list">
          {visibleConversations.map((row) => {
            const checked = selectedIds.has(row.id);
            return (
              <button
                key={row.id}
                className={`forward_row ${checked ? "selected" : ""}`}
                onClick={() => toggleSelect(row.id)}
              >
                <img className="forward_avatar" src={row.avatar} alt={row.title} />
                <span className="forward_title">{row.title}</span>
                <span className="forward_check">{checked ? "✓" : ""}</span>
              </button>
            );
          })}
        </div>

        <div className="forward_actions">
          <button className="forward_cancel_btn" onClick={onClose}>Cancel</button>
          <button
            className="forward_send_btn"
            disabled={!selectedIds.size || isSubmitting}
            onClick={handleConfirm}
          >
            {isSubmitting ? "Forwarding..." : `Forward (${selectedIds.size})`}
          </button>
        </div>
      </div>
    </div>
  );
}
